import { useStaticQuery, graphql } from 'gatsby';
import { footerDataMapping } from '@/helpers/mapHelpers';

const useTermConditionAndDataProtection = (custType: string) => {
  const data = useStaticQuery(graphql`
    {
      termConditionAndDataProtection {
        dataProtection
        termsAndConditions {
          type
          value
        }
      }
      termConditionStaffPlan {
        staffplantc
      }
    }
  `);
  return footerDataMapping({
    dataProtection: data?.termConditionAndDataProtection.dataProtection,
    termsAndConditions: data?.termConditionAndDataProtection.termsAndConditions,
    staffPlanTc: data?.termConditionStaffPlan?.staffplantc,
    custType
  });
};

export default useTermConditionAndDataProtection;
